var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Pagination } from '../../../packages/core/Pagination';
import Icon from 'common/UIToolKit/Icon.vue';
import UiButton from './UiButton.vue';
var PAGE_CHANGE_EVENT = 'pageChange';
var UiPaginationControls = /** @class */ (function (_super) {
    __extends(UiPaginationControls, _super);
    function UiPaginationControls() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(UiPaginationControls.prototype, "isLastPage", {
        get: function () {
            return (this.paging && this.paging.lastPage === this.paging.currentPage);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UiPaginationControls.prototype, "isFirstPage", {
        get: function () {
            return this.paging.currentPage === 1;
        },
        enumerable: false,
        configurable: true
    });
    UiPaginationControls.prototype.next = function () {
        if (!this.active || this.isLastPage) {
            return;
        }
        this.paging.currentPage += 1;
        this.$emit(PAGE_CHANGE_EVENT, this.paging);
    };
    UiPaginationControls.prototype.previous = function () {
        if (!this.active || this.isFirstPage) {
            return;
        }
        this.paging.currentPage -= 1;
        this.$emit(PAGE_CHANGE_EVENT, this.paging);
    };
    UiPaginationControls.prototype.goToFirstPage = function () {
        if (!this.active) {
            return;
        }
        this.paging.currentPage = 1;
        this.$emit(PAGE_CHANGE_EVENT, this.paging);
    };
    UiPaginationControls.prototype.goToLastPage = function () {
        if (!this.active || !this.paging || this.isLastPage) {
            return;
        }
        this.paging.currentPage = this.paging.lastPage;
        this.$emit(PAGE_CHANGE_EVENT, this.paging);
    };
    var _a;
    __decorate([
        Prop(),
        __metadata("design:type", typeof (_a = typeof Pagination !== "undefined" && Pagination) === "function" ? _a : Object)
    ], UiPaginationControls.prototype, "paging", void 0);
    __decorate([
        Prop({ default: true }),
        __metadata("design:type", Boolean)
    ], UiPaginationControls.prototype, "active", void 0);
    UiPaginationControls = __decorate([
        Component({
            components: {
                Icon: Icon,
                UiButton: UiButton,
            },
            model: {
                prop: 'paging',
                event: PAGE_CHANGE_EVENT,
            },
        })
    ], UiPaginationControls);
    return UiPaginationControls;
}(Vue));
export default UiPaginationControls;
